"use client";

import React, { useState } from "react";
// import CustomModal from "@/components/ui/modal/modal";
import { Button } from "@/components/ui/button/button";
import Image from "next/image";
import { IconCheck, IconCopy, IconExternalLink } from "@tabler/icons-react";
import Link from "next/link";
import Modal from "./modal";
import toast from "react-hot-toast";

interface TokenSuccessModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tokenAddress: string | null;
}

const TokenSuccessModalBuilder: React.FC<TokenSuccessModalProps> = ({
  open,
  onOpenChange,
  tokenAddress,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (tokenAddress) {
      await navigator.clipboard.writeText(tokenAddress);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } else {
      toast.error("Failed to copy token address");
    }
  };

  return (
    <Modal open={open} onOpenChange={onOpenChange} className="max-w-xl w-full">
      <div className="flex flex-col items-center gap-4 md:pt-64 pt-38">
        <div className="absolute top-0">
          <Image
            src="/assets/success_token.svg"
            alt="token created"
            width={100}
            height={100}
            className="mb-2 md:w-36 w-24  h-auto"
          />
        </div>

        <h2 className="text-white text-3xl font-semibold text-center">
          Token Created Successfully
        </h2>

        <div className="w-full text-left space-y-2">
          <p className="text-sm text-muted text-gray-100 text-center">
            Token Address
          </p>
          <div
            onClick={handleCopy}
            className="group flex items-center bg-input-bgcolor border border-primaryborder rounded-lg px-4 py-2 cursor-pointer hover:border-white/50 transition-colors"
          >
            <input
              value={tokenAddress || ""}
              readOnly
              className="w-full text-center text-white text-sm bg-transparent outline-none "
            />

            <div className="ml-2 text-white/80 group-hover:text-white relative">
              {copied ? (
                <IconCheck size={18} className="text-green-400" />
              ) : (
                <IconCopy size={18} />
              )}
              {copied && (
                <span className="absolute -top-8 left-1/2 -translate-x-1/2 text-xs text-green-400">
                  Copied!
                </span>
              )}
            </div>
          </div>
        </div>

        <div className="flex flex-col w-full space-y-2">
          {/* <Link target="_blank" href={"/"}>
            <Button className="w-full bg-[#111117] border border-primaryborder hover:bg-white/20 text-white rounded-lg text-md py-2">
              <IconExternalLink size={18} className="mr-2" /> Create Liquidity
              Pool
            </Button>
          </Link> */}
          <Link target="_blank" href={`/builder-token/${tokenAddress}`}>
            <Button className="w-full bg-[#111117] border border-primaryborder hover:bg-white/20 text-white rounded-lg text-md py-2">
              <IconExternalLink size={18} className="mr-2" /> View the Token
            </Button>
          </Link>
          <Link
            target="_blank"
            href={`https://explorer.solana.com/address/${tokenAddress}?cluster=devnet`}
          >
            <Button className="w-full bg-[#111117] border border-primaryborder hover:bg-white/20 text-white rounded-lg text-md py-2">
              <IconExternalLink size={18} className="mr-2" /> View on Explorer
            </Button>
          </Link>

          <Link
            target="_blank"
            href={`https://solscan.io/token/${tokenAddress}?cluster=devnet`}
          >
            <Button className="w-full bg-[#111117] border border-primaryborder hover:bg-white/20 text-white rounded-lg text-md py-2">
              <IconExternalLink size={18} className="mr-2" /> View on Solscan
            </Button>
          </Link>
        </div>

        {/* <p className="text-muted text-xs text-offwhite mt-2 border-t-2 border-primaryborder pt-4 w-full text-left">
          Add this token to your wallet using the token address above.
        </p> */}
      </div>
    </Modal>
  );
};

export default TokenSuccessModalBuilder;
